module.exports = __webpack_public_path__ + "static/media/registp03_zhCht.941db325.png";